// This global pack is loaded for every page in the app (public, operator, crew, etc) and every online app and native app webview.
// This pack is rendered inline with the page head and should be executed before any other packs.
// It's a good place to put critical constants, helpers and components that are used across the board. But be very selective as we want to keep the bundle size very small.

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// `rankersNamespace` function provides a consistent way to access the Rankers namespace on the global window object.
import {getRankersNamespace} from "../rankers/constants/rankers_namespace";
window.getRankersNamespace = getRankersNamespace; // Expose this function on the global window object.

// These functions allow for consistent access to the Rankers user agent header value on the global window object.
// The value is set on every page load that uses the `/app/views/layouts/shared/_head.html.erb` partial.
import {setRankersUserAgent, getRankersUserAgent} from "../rankers/constants/rankers_user_agent";
getRankersNamespace().setRankersUserAgent = setRankersUserAgent;
getRankersNamespace().getRankersUserAgent = getRankersUserAgent;

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Import Rankers helper functions
// Helpers are small utility functions.
// These functions must be imported and then exposed on the window object so the can continue to be accessed via the global scope.
// We should nest them inside the `window.RankersHelpers` object to avoid collisions.
window.RankersHelpers ??= {};

// The following helpers are used by scripts and components that are loaded after the global pack.

import DOMready from '../rankers/helpers/dom_ready';
window.RankersHelpers.DOMready = DOMready;

import DOMUpdateEvent from "../rankers/helpers/dom_update_event";
window.RankersHelpers.DOMUpdateEvent = DOMUpdateEvent;

import {injectLibrary, injectStylesheet} from "../rankers/helpers/injection";
window.RankersHelpers.injectLibrary = injectLibrary;
window.RankersHelpers.injectStylesheet = injectStylesheet;
